import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useRequest } from 'hooks';

import Modal from 'components/Modal';
import { Button } from 'components/Misc/Form';

import { useExamStudentStore } from 'store/exam/useExamStudentStore';

const End = () => {
	// Store current take id
	const { id } = useParams();

	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Use exam's store
	const [answers, onEnd] = useExamStudentStore(state => [state.answers, state.onEnd]);

	// Store update request
	const [[progress], request] = useRequest('put', `takes/${id}`);

	// Handle modal's visibility
	const onModal = () => setModal(prev => !prev);

	// Handle take's end
	const onSubmit = async (event) => {
		event.preventDefault();

		// Do not submit twice
		if (progress) return;

		// Try to end exam
		const [success, error] = await request(answers, { action: 'end' });

		// Handle takes ending
		if (success) {
			// Hide modal
			setModal(false);

			// Update take's state
			return onEnd({
				state: success.state,
				endedAt: success.endedAt
			});
		}

		// Handle take's ending
		if (error?.message === 'takeHasEnded') {
			// Hide modal
			setModal(false);

			// Update take's state
			return onEnd({
				state: 'finished'
			});
		}
	};

	return (
		<>
			<Button
				icon="done"
				value="Iesniegt"
				theme="success"
				onClick={onModal}
			/>

			<Modal title="Iesniegt pārbaudes darbu" visible={modal} handleModal={onModal}>
				<div className="space-y-4">
					<div className="text-neutral-800 dark:text-white transition-colors">
						Uzmanību! Nospiežot pogu <b>&quot;Iesniegt&quot;</b> pārbaudes darbs tiks nodots pedagogam!
					</div>

					<div className="flex justify-end space-x-2">
						<Button
							icon="close"
							value="Atcelt"
							theme="warning"
							onClick={onModal}
						/>

						<Button
							icon="done"
							value="Iesniegt"
							theme="success"
							progress={progress}
							onClick={onSubmit}
						/>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default End;